import styled from "styled-components";
import { AutoColumn } from "../../../components/Column";
import { AutoRow, RowBetween } from "../../../components/Row";
import Row from "../../../components/Row";
import useToken from "../../../hooks/useToken";
import { ButtonLight,ButtonOutlined, ButtonPrimary } from "../../../components/Button";
import { SecondsToTime, toAmount, toSpecialAmount } from "../../../utils/amount";
import { shortenAddress } from "../../../utils";

import CurrencyLogo from "../../../components/CurrencyLogo";
import { Trans } from "@lingui/macro";
import { useWallet } from "use-wallet";
import { useEffect, useMemo, useState } from "react";
import { BLOCK_PER_SEC } from "../../../constants/chains";
import { zeroPad } from "react-countdown";

import Big from "big.js";
import { TOKEN_ADDRESS } from "../../../constants/address";
import { NodeType,AppType,BusinessType } from "../../../constants/dict";

const PoolItemWrapper = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 12px;
  background-color: white;
  padding: 1em;
  min-height: 228.5px;
  font-size: 14px;
`;

const APYText = styled.div`
  color: ${({ theme }) => theme.yellow2};
  font-size: 20px;
`;

const ItemActionWrapper = styled.div`
  display: flex;
  margin-top: 12px;

  & > * {
    flex: 1;
    margin-right: 8px;
  }

  & > *:last-child {
    margin-right: unset;
  }
`;

const ValueText = styled.div`
  font-size: 14px;
`;

const HR = styled.div`
  width: 100%;
  border-bottom: 1px dashed ${({ theme }) => theme.bg2};
`;

function UserNodeItem({ userPkgInfo,setUpdateopen,setPledgeopen,setCurUserNodeItem,nodeAppsObj, nodeOpt }) {
  // const { account,chainId  } = useWallet(); // getBlockNumber


  return (
    <PoolItemWrapper>
      {userPkgInfo && userPkgInfo.nodeid ? (
        <AutoColumn gap={"12px"}>
          <RowBetween justify={"space-between"}>
            <AutoRow gap={"8px"}>
              {/* <CurrencyLogo src={token.icon} size={"48px"} /> */}
              <AutoColumn>
                <div style={{ fontSize: "16px" }}>
                  <Trans> {userPkgInfo.desc}</Trans>
                </div>
                {/*              <div style={ { fontSize: '16px' } }>
                  <Trans>Earn</Trans>
                </div> */}
              </AutoColumn>
            </AutoRow>
            <div>#{userPkgInfo.nodeid}</div>
          </RowBetween>

          <HR />
          <AutoRow justify={"space-between"}>
            <div>
              <Trans>NodeType</Trans>
            </div>
            <ValueText>{NodeType[userPkgInfo.nodetype]}</ValueText>
          </AutoRow>

          <AutoRow justify={"space-between"}>
            <div>
              <Trans>App</Trans>
            </div>
            <ValueText>{nodeAppsObj[userPkgInfo.appgroup] && nodeAppsObj[userPkgInfo.appgroup].name}{'('}{userPkgInfo.appgroup}{')'}</ValueText>
          </AutoRow>


          <AutoRow justify={"space-between"}>
            <div>
              <Trans>StartTime</Trans>
            </div>
            <ValueText>{SecondsToTime(userPkgInfo.nodestarttime)} </ValueText>
          </AutoRow>

          <AutoRow justify={"space-between"}>
            <div>
              <Trans>EndTime</Trans>
            </div>
            <ValueText>{userPkgInfo.endstarttime>0?SecondsToTime(userPkgInfo.endstarttime):''} </ValueText>
          </AutoRow>

          <AutoRow justify={"space-between"}>
            <div>
              <Trans>Node Address</Trans>
            </div>
            <ValueText>{shortenAddress(userPkgInfo.nodeAddr)} </ValueText>
          </AutoRow>
          <AutoRow justify={"space-between"}>
            <div>
              <Trans>Reward Address</Trans>
            </div>
            <ValueText>{shortenAddress(userPkgInfo.rewardAddr)} </ValueText>
          </AutoRow>
{/*           <AutoRow justify={"space-between"}>
            <div>
              <Trans>Apps</Trans>
            </div>
            <ValueText>{userPkgInfo.appgroup}</ValueText>
          </AutoRow> */}


<HR />
<ItemActionWrapper>
            <ButtonLight
            padding={"8px"}
            width={"140px"}
            onClick={() => { 
              setUpdateopen(true);
              setCurUserNodeItem(userPkgInfo);
            }}
            >
              <Trans>Update</Trans>
            </ButtonLight>
            <ButtonOutlined
             padding={"8px"}
              width={"140px"}
              onClick={() => { 
                setPledgeopen(true);
              setCurUserNodeItem(userPkgInfo);
            }}
            >
              <Trans>Pledge</Trans>
            </ButtonOutlined>
          </ItemActionWrapper>
 

        </AutoColumn>
      ) : null}
     
{/*       <PoolDepositModal
        isOpen={depositOpen}
        setIsOpen={setDepositOpen}
        depositToken={pledgeToken}
        userInfo={userInfo}
        pkgitem={pkgitem}
        miniPool={miniPool}
      /> */}
    </PoolItemWrapper>
  );
}

export default UserNodeItem;
